import { getMatchedBrowsePrimaryFocus } from '@/domain/term/useCases/getMatchedBrowsePrimaryFocus'
import { SearchState } from '@/types/models'
import {
  isNonEmptyArray,
  isNonEmptyObject,
  isNonEmptyString
} from '@/utils/checks'
import { PrimaryFocus } from '../constant'

export const findPrimaryFocus = ({
  searchState,
  primaryFocusMap
}: {
  searchState: SearchState
  primaryFocusMap: Record<string, PrimaryFocus>
}): PrimaryFocus | string => {
  if (!isNonEmptyObject(primaryFocusMap) || !isNonEmptyObject(searchState)) {
    return ''
  }

  if (isNonEmptyArray(searchState?.refinementList?.what_we_treat)) {
    const primaryFocusBrowse = getMatchedBrowsePrimaryFocus({
      searchState,
      primaryFocusMap
    })

    return primaryFocusBrowse
  }
  if (isNonEmptyString(searchState?.refinementList?.what_we_treat)) {
    return primaryFocusMap[searchState.refinementList.what_we_treat]
  }

  return ''
}
